import React, {useState} from "react"
import styled from "styled-components";

const OptIn = ({mode,number,cancel,start,kickstart}) => {
    const [agreed, setAgreed] = useState(false);
  return (
    <OptInContainer>
        <h2>Start {mode} conversation</h2>
        {mode==="web" && (
            <div style={{display:"flex", justifyContent:"center", gap:"15px"}}>
                <OutlinedButton onClick={cancel}>Cancel</OutlinedButton>
                <Button onClick={start}>Chat Now</Button>
            </div>
        )}
        {mode==="sms" && (
            <div style={{textAlign:"left", display:"flex", flexDirection:"column", gap:"15px", fontSize:"12px"}}>
                <div>
                    Number: {number}<br/>
                    If this number is invalid, please update your profile and try again.
                </div>
                <div>
                    <input type="checkbox" onClick={()=>setAgreed(!agreed)}/>
                    <label> I agree to receive messages from Freede for this conversation and any requested follow-up. You also agree to our Terms of Service and Privacy Policy. Msg freq. varies. Msg & Date rates may apply. Reply STOP to end or HELP for help.</label>
                </div>
                <div style={{display:"flex", justifyContent:"center", gap:"15px"}}>
                    <OutlinedButton onClick={cancel}>Cancel</OutlinedButton>
                    <Button onClick={kickstart} disabled={!agreed}>Start SMS</Button>
                </div>
            </div>

        )}
        <p>This chat bot does not provide financial advice and is not monitored by humans. It uses developing AI technology to provide general information for your convenience. Do not enter personal information that could identify you into the chat. To learn how we use your personal information, please see our Privacy Policy.</p>
    </OptInContainer>
  )
}

const OptInContainer = styled.div`
  /* Freede glassy card on the dark platform background */
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 20px;
  margin-left: auto;
  margin-right: auto;
  max-width: 400px;
  width: calc(100% - 32px);
  box-sizing: border-box;
  color: #ffffff;

  text-align: center;

  p {
    margin-top: 30px;
    font-size: 11px;
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
  }
`;

const Button = styled.button`
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  border: none;
  border-radius: 16px;
  padding: 10px 16px;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 600;

  // Disabled style
    &:disabled {
        background: rgba(255, 255, 255, 0.15);
        color: rgba(255, 255, 255, 0.4);
        cursor: not-allowed;
    }
`;

const OutlinedButton = styled.button`
  border-color: rgba(255, 255, 255, 0.2);
  background-color: transparent;
  color: rgba(255, 255, 255, 0.8);
  border-style: solid;
  border-width: 1px;
  border-radius: 16px;
  padding: 10px 16px;
  outline: none;
  cursor: pointer;
  font-family: inherit;
`;
export default OptIn
